// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoryTitle_container__Lmtg_","button":"CategoryTitle_button__5tEtX"};